import { render } from "./Table.vue?vue&type=template&id=6ba8da90"
import script from "./Table.js?vue&type=script&lang=js"
export * from "./Table.js?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__